export enum CompanyFeatures {
  ANALYTICS = 'ANALYTICS',
  CONNECT = 'CONNECT',
  CONNECT_COACHING = 'CONNECT_COACHING',
  CONNECT_SOCIALISE = 'CONNECT_SOCIALISE',

  FEEDBACK = 'FEEDBACK',
  FEEDBACK_DASHBOARD = 'FEEDBACK_DASHBOARD',
  FEEDBACK_UNPROMPTED = 'FEEDBACK_UNPROMPTED',
  FEEDBACK_PRAISE = 'FEEDBACK_PRAISE',
  FEEDBACK_IDEAS = 'FEEDBACK_IDEAS',
  FEEDBACK_PEER = 'FEEDBACK_PEER',
  FEEDBACK_REQUESTS = 'FEEDBACK_REQUESTS',

  GOALS = 'GOALS',

  HELP = 'HELP',

  PEOPLE_DIRECTORY = 'PEOPLE_DIRECTORY',
  RESTRICT_PROFILE_ACCESS = 'RESTRICT_PROFILE_ACCESS',
  RESTRICT_PROFILE_ACCESS_SUBORDINATES_ONLY = 'RESTRICT_PROFILE_ACCESS_SUBORDINATES_ONLY',
  CALENDAR_ALLOW_DIFFERENT_EMAIL = 'CALENDAR_ALLOW_DIFFERENT_EMAIL',
  SURVEYS = 'SURVEYS',

  ORG_CHART = 'ORG_CHART',
  ORG_CHART_GOALS_INFO = 'ORG_CHART_GOALS_INFO',

  ONE_TO_ONE = 'ONE_TO_ONE',

  GOAL_PRIORITY = 'GOAL_PRIORITY',
  GOAL_TEMPLATE = 'GOAL_TEMPLATE',
  GOAL_OFFICE_LOCATION = 'GOAL_OFFICE_LOCATION',

  EVALUATION_CYCLES = 'EVALUATION_CYCLES',
  PEER_NOMINATIONS = 'PEER_NOMINATIONS',

  COMPETENCIES = 'COMPETENCIES',
  DEPRECATED_GRADES = 'DEPRECATED_GRADES',
  TODOS = 'TODOS',

  SSO = 'SSO',
  SSO_MICROSOFT = 'SSO_MICROSOFT',
  SSO_GOOGLE = 'SSO_GOOGLE',

  ENPS = 'ENPS',
  FEEDBACK_BANK = 'FEEDBACK_BANK',
  FEEDBACK_EXTERNAL_REQUESTS = 'FEEDBACK_EXTERNAL_REQUESTS',
  PEER_FEEDBACK_MANAGER_ACCESS = 'PEER_FEEDBACK_MANAGER_ACCESS',

  AZURE_ACTIVE_DIRECTORY = 'AZURE_ACTIVE_DIRECTORY',
  PEOPLE_HR = 'PEOPLE_HR',
  LOGIN_EMAIL_PASSWORD = 'LOGIN_EMAIL_PASSWORD',
  CONNECT_MENTORING = 'CONNECT_MENTORING',
  SECONDARY_MANAGER = 'SECONDARY_MANAGER',
  VINCERE = 'VINCERE',
  TRINET_HRIS = 'TRINET_HRIS',
  SAGE_HR = 'SAGE_HR',
  ZENDESK = 'ZENDESK',
  SKILLS = 'SKILLS',
  QUALIFICATIONS = 'QUALIFICATIONS',

  CAREERS = 'CAREERS',
  CAREER_PATHWAYS = 'CAREER_PATHWAYS',
  ROLE_APPLICATIONS = 'ROLE_APPLICATIONS',
  QUESTION_TEMPLATES = 'QUESTION_TEMPLATES',
  CUSTOM_CAREER_PATHWAYS = 'CUSTOM_CAREER_PATHWAYS',

  COMPANY_DASHBOARD_CARD = 'COMPANY_DASHBOARD_CARD',
  EVALUAGENT = 'EVALUAGENT',
  MERGE = 'MERGE',
  ABSORBLMS = 'ABSORBLMS',

  ONE_TO_ONE_SENTIMENT_SCALE = 'ONE_TO_ONE_SENTIMENT_SCALE',

  SKILL_RATING = 'SKILL_RATING',
  ZENDESKQA = 'ZENDESKQA',

  AI_PROMPTS = 'AI_PROMPTS',
  AI_SHORTCUTS = 'AI_SHORTCUTS',
  GOAL_WEIGHTING = 'GOAL_WEIGHTING',
  CUSTOM_USER_FIELD = 'CUSTOM_USER_FIELD',
  ROLE_APPLICATION_MANAGER_LOCK = 'ROLE_APPLICATION_MANAGER_LOCK',
  EVALUATION_ONE_TO_ONE_PROMPT = 'EVALUATION_ONE_TO_ONE_PROMPT',
}